import { defineFcm } from '../shared/factory';

export const FCM_SIGN_PETITION_AS_GUEST_MUTATION = defineFcm('sign_petition_as_guest_mutation')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'petition page',
		description:
			'If true, guests sign from the petition page sign form through the signPetitionAsGuest mutation instead of signPetition.',
	});
